module.exports = __webpack_public_path__ + "img/fd_120.da7b950c.png";